import { Facebook } from "lucide-react";

export const SOCIAL_LINKS = [
  {
    name: "Facebook",
    handle: "thetealist",
    href: "https://www.facebook.com/thetealist",
    Icon: Facebook,
  },
];

/**
 * Compact social icons row.
 *
 * @param {"sm"|"md"|"lg"} size – icon size preset
 * @param {boolean} showHandles – render the @handle next to each icon
 * @param {string} className – extra container classes
 * @param {string[]} exclude – platform names (case-insensitive) to omit
 */
export default function SocialIcons({
  size = "md",
  showHandles = false,
  className = "",
  exclude = [],
  linkClassName = "text-[#404e48] hover:text-[#1e4a35]",
}) {
  const SIZE_PX = { sm: 14, md: 16, lg: 20 };
  const px = SIZE_PX[size] ?? SIZE_PX.md;
  const gap = size === "lg" ? "gap-5" : "gap-4";
  const excluded = new Set(exclude.map((s) => String(s).toLowerCase()));
  const links = SOCIAL_LINKS.filter((l) => !excluded.has(l.name.toLowerCase()));
  return (
    <div
      className={`flex items-center ${gap} ${className}`}
      data-testid="social-icons"
    >
      {links.map(({ name, handle, href, Icon }) => (
        <a
          key={name}
          href={href}
          target="_blank"
          rel="me noopener noreferrer"
          aria-label={`The Tea List on ${name}`}
          title={`${name} — ${handle}`}
          className={`inline-flex items-center gap-2 transition-colors ${linkClassName}`}
          data-testid={`social-link-${name.toLowerCase()}`}
        >
          <Icon size={px} strokeWidth={1.7} />
          {showHandles && (
            <span className="font-mono text-[10px] tracking-widest uppercase">
              {handle}
            </span>
          )}
        </a>
      ))}
    </div>
  );
}
